module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_add-to-unscopables.js
// module id = 286
// module chunks = 168707334958949